"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = require("styled-components");
var global_1 = __importDefault(require("./styles/global"));
var routes_1 = __importDefault(require("./routes"));
var dark_1 = __importDefault(require("./styles/themes/dark"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
function App() {
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsxs)(styled_components_1.ThemeProvider, __assign({ theme: dark_1.default }, { children: [(0, jsx_runtime_1.jsx)(global_1.default, {}), (0, jsx_runtime_1.jsx)(routes_1.default, {})] })) }));
}
exports.default = App;
